import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <main className="container-wide py-24 text-center">
      <div className="eyebrow justify-center"><span className="inline-block h-1.5 w-6 rounded-full bg-[hsl(var(--green))]" /> 404</div>
      <h1 className="heading-1 mt-3">Page not found</h1>
      <p className="lead mt-3 max-w-lg mx-auto">The page you’re looking for doesn’t exist or may have been moved.</p>
      <Link to="/" className="inline-block mt-6"><Button className="bg-[hsl(var(--navy))] hover:bg-[hsl(var(--navy-2))] text-background">Go home</Button></Link>
    </main>
  );
}
